// extracted by mini-css-extract-plugin
export var accent = "_bv-4";
export var add = "_bv-j";
export var addIcon = "_bv-k";
export var deleteIcon = "_bv-i";
export var disabled = "_bv-9";
export var ellipsis = "_bv-f";
export var error = "_bv-3";
export var form = "_bv-5";
export var hideFocus = "_bv-2";
export var icon = "_bv-7";
export var input = "_bv-e";
export var listItem = "_bv-h";
export var mediumHeight = "_bv-b";
export var noBorder = "_bv-8";
export var noRadius = "_bv-1";
export var shortHeight = "_bv-a";
export var tallHeight = "_bv-c";
export var textInput = "_bv-0";
export var vertical = "_bv-g";
export var veryTallHeight = "_bv-d";
export var widget = "_bv-6";